export enum BroadcastChannelMessages {
  'ask_for_ameyo_initiation' = 'ask_for_ameyo_initiation',
  'already_initialized' = 'already_initiated'
}
